import React from 'react';
import { format } from 'date-fns';

import type { EventsVariants } from 'Theme/types/components.type';

import Pill from 'Elements/Pill';
import ArrowLink, { ArrowLinkProps } from 'Elements/Link/Arrow';

import { Event, EventHeading, DateWrapper, Date, Flex } from './OpenDay.styled';

export interface Props {
    id: string;
    type: string;
    date: Date;
    delivery: string;
    link: ArrowLinkProps;
    variant: EventsVariants;
}

const OpenDay: React.FC<Props> = props => {
    const { id, type, date, delivery, link, variant } = props;

    const day = format(date, 'EEEE');
    const rest = format(date, 'd MMMM yyyy');

    return (
        <Event id={id} $variant={variant}>
            <EventHeading>{type}</EventHeading>
            <DateWrapper>
                <Date>{day}</Date>
                <Date>{rest}</Date>
            </DateWrapper>
            <Flex>
                <Pill showBorder backgroundColor="transparent">
                    {delivery}
                </Pill>
                <ArrowLink {...link} variant="text" iconOutline>
                    Book now
                </ArrowLink>
            </Flex>
        </Event>
    );
};

export default OpenDay;
